export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/react-router/es/PromiseUtils.js
// module id = 58
// module chunks = 0